/** Console API slice for Hub "Just for you" custom agents (Agent Library). */

import { consoleApiSlice } from "./consoleApiSlice";

export const customAgentsApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomAgents: builder.query({
      query: ({ env, search }) => ({
        url: `/api/v1/custom-agents/${env}`,
        params: search ? { search } : undefined,
      }),
      providesTags: (result, _err, { env }) =>
        result?.agents
          ? [
              ...result.agents.map((a) => ({
                type: "CustomAgents",
                id: `${env}:${a.slug}`,
              })),
              { type: "CustomAgents", id: `${env}:LIST` },
            ]
          : [{ type: "CustomAgents", id: `${env}:LIST` }],
    }),

    getCustomAgentDetail: builder.query({
      query: ({ env, slug }) => `/api/v1/custom-agents/${env}/${slug}`,
      providesTags: (_r, _e, { env, slug }) => [
        { type: "CustomAgents", id: `${env}:${slug}` },
      ],
    }),

    patchCustomAgent: builder.mutation({
      query: ({ env, slug, updates }) => ({
        url: `/api/v1/custom-agents/${env}/${slug}`,
        method: "PATCH",
        body: updates,
      }),
      invalidatesTags: (_r, _e, { env, slug }) => [
        { type: "CustomAgents", id: `${env}:${slug}` },
        { type: "CustomAgents", id: `${env}:LIST` },
      ],
    }),

    getCustomAgentFile: builder.query({
      query: ({ env, slug, key }) => ({
        url: `/api/v1/custom-agents/${env}/${slug}/file`,
        params: { key },
      }),
      providesTags: (_r, _e, { env, slug, key }) => [
        { type: "CustomAgentFile", id: `${env}:${slug}:${key}` },
      ],
    }),

    putCustomAgentFile: builder.mutation({
      query: ({ env, slug, key, contents }) => ({
        url: `/api/v1/custom-agents/${env}/${slug}/file`,
        method: "PUT",
        body: { key, contents },
      }),
      invalidatesTags: (_r, _e, { env, slug, key }) => [
        { type: "CustomAgentFile", id: `${env}:${slug}:${key}` },
        { type: "CustomAgents", id: `${env}:${slug}` },
      ],
    }),

    putCustomAgentFrontmatter: builder.mutation({
      query: ({ env, slug, key, frontmatter, body }) => ({
        url: `/api/v1/custom-agents/${env}/${slug}/frontmatter`,
        method: "PUT",
        body: { key, frontmatter, body },
      }),
      invalidatesTags: (_r, _e, { env, slug, key }) => [
        { type: "CustomAgentFile", id: `${env}:${slug}:${key}` },
        { type: "CustomAgents", id: `${env}:${slug}` },
      ],
    }),
  }),
});

export const {
  useGetCustomAgentsQuery,
  useGetCustomAgentDetailQuery,
  usePatchCustomAgentMutation,
  useGetCustomAgentFileQuery,
  useLazyGetCustomAgentFileQuery,
  usePutCustomAgentFileMutation,
  usePutCustomAgentFrontmatterMutation,
} = customAgentsApiSlice;
